var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}
parcelRequire.register("brAMX", function(module, exports) {

$parcel$export(module.exports, "fromEvents", () => fromEvents);
$parcel$export(module.exports, "merge", () => merge);
/*! Kefir.js v3.8.8
 *  https://github.com/kefirjs/kefir
 */ function createObj(proto) {
    var F = function() {};
    F.prototype = proto;
    return new F();
}
function extend(target /*, mixin1, mixin2...*/ ) {
    var length = arguments.length, i = void 0, prop = void 0;
    for(i = 1; i < length; i++)for(prop in arguments[i])target[prop] = arguments[i][prop];
    return target;
}
function inherit(Child, Parent /*, mixin1, mixin2...*/ ) {
    var length = arguments.length, i = void 0;
    Child.prototype = createObj(Parent.prototype);
    Child.prototype.constructor = Child;
    for(i = 2; i < length; i++)extend(Child.prototype, arguments[i]);
    return Child;
}
var NOTHING = [
    "<nothing>"
];
var END = "end";
var VALUE = "value";
var ERROR = "error";
var ANY = "any";
function concat(a, b) {
    var result = void 0, length = void 0, i = void 0, j = void 0;
    if (a.length === 0) return b;
    if (b.length === 0) return a;
    j = 0;
    result = new Array(a.length + b.length);
    length = a.length;
    for(i = 0; i < length; i++, j++)result[j] = a[i];
    length = b.length;
    for(i = 0; i < length; i++, j++)result[j] = b[i];
    return result;
}
function find(arr, value) {
    var length = arr.length, i = void 0;
    for(i = 0; i < length; i++){
        if (arr[i] === value) return i;
    }
    return -1;
}
function findByPred(arr, pred) {
    var length = arr.length, i = void 0;
    for(i = 0; i < length; i++){
        if (pred(arr[i])) return i;
    }
    return -1;
}
function cloneArray(input) {
    var length = input.length, result = new Array(length), i = void 0;
    for(i = 0; i < length; i++)result[i] = input[i];
    return result;
}
function remove(input, index) {
    var length = input.length, result = void 0, i = void 0, j = void 0;
    if (index >= 0 && index < length) {
        if (length === 1) return [];
        else {
            result = new Array(length - 1);
            for(i = 0, j = 0; i < length; i++)if (i !== index) {
                result[j] = input[i];
                j++;
            }
            return result;
        }
    } else return input;
}
function map(input, fn) {
    var length = input.length, result = new Array(length), i = void 0;
    for(i = 0; i < length; i++)result[i] = fn(input[i]);
    return result;
}
function forEach(arr, fn) {
    var length = arr.length, i = void 0;
    for(i = 0; i < length; i++)fn(arr[i]);
}
function fillArray(arr, value) {
    var length = arr.length, i = void 0;
    for(i = 0; i < length; i++)arr[i] = value;
}
function contains(arr, value) {
    return find(arr, value) !== -1;
}
function slide(cur, next, max) {
    var length = Math.min(max, cur.length + 1), offset = cur.length - length + 1, result = new Array(length), i = void 0;
    for(i = offset; i < length; i++)result[i - offset] = cur[i];
    result[length - 1] = next;
    return result;
}
function callSubscriber(type, fn, event) {
    if (type === ANY) fn(event);
    else if (type === event.type) {
        if (type === VALUE || type === ERROR) fn(event.value);
        else fn();
    }
}
function Dispatcher() {
    this._items = [];
    this._spies = [];
    this._inLoop = 0;
    this._removedItems = null;
}
extend(Dispatcher.prototype, {
    add: function(type, fn) {
        this._items = concat(this._items, [
            {
                type: type,
                fn: fn
            }
        ]);
        return this._items.length;
    },
    remove: function(type, fn) {
        var index = findByPred(this._items, function(x) {
            return x.type === type && x.fn === fn;
        });
        // if we're currently in a notification loop,
        // remember this subscriber was removed
        if (this._inLoop !== 0 && index !== -1) {
            if (this._removedItems === null) this._removedItems = [];
            this._removedItems.push(this._items[index]);
        }
        this._items = remove(this._items, index);
        return this._items.length;
    },
    addSpy: function(fn) {
        this._spies = concat(this._spies, [
            fn
        ]);
        return this._spies.length;
    },
    // Because spies are only ever a function that perform logging as
    // their only side effect, we don't need the same complicated
    // removal logic like in remove()
    removeSpy: function(fn) {
        this._spies = remove(this._spies, this._spies.indexOf(fn));
        return this._spies.length;
    },
    dispatch: function(event) {
        this._inLoop++;
        for(var i = 0, spies = this._spies; this._spies !== null && i < spies.length; i++)spies[i](event);
        for(var _i = 0, items = this._items; _i < items.length; _i++){
            // cleanup was called
            if (this._items === null) break;
            // this subscriber was removed
            if (this._removedItems !== null && contains(this._removedItems, items[_i])) continue;
            callSubscriber(items[_i].type, items[_i].fn, event);
        }
        this._inLoop--;
        if (this._inLoop === 0) this._removedItems = null;
    },
    cleanup: function() {
        this._items = null;
        this._spies = null;
    }
});
function Observable() {
    this._dispatcher = new Dispatcher();
    this._active = false;
    this._alive = true;
    this._activating = false;
    this._logHandlers = null;
    this._spyHandlers = null;
}
extend(Observable.prototype, {
    _name: "observable",
    _onActivation: function() {},
    _onDeactivation: function() {},
    _setActive: function(active) {
        if (this._active !== active) {
            this._active = active;
            if (active) {
                this._activating = true;
                this._onActivation();
                this._activating = false;
            } else this._onDeactivation();
        }
    },
    _clear: function() {
        this._setActive(false);
        this._dispatcher.cleanup();
        this._dispatcher = null;
        this._logHandlers = null;
    },
    _emit: function(type, x) {
        switch(type){
            case VALUE:
                return this._emitValue(x);
            case ERROR:
                return this._emitError(x);
            case END:
                return this._emitEnd();
        }
    },
    _emitValue: function(value) {
        if (this._alive) this._dispatcher.dispatch({
            type: VALUE,
            value: value
        });
    },
    _emitError: function(value) {
        if (this._alive) this._dispatcher.dispatch({
            type: ERROR,
            value: value
        });
    },
    _emitEnd: function() {
        if (this._alive) {
            this._alive = false;
            this._dispatcher.dispatch({
                type: END
            });
            this._clear();
        }
    },
    _on: function(type, fn) {
        if (this._alive) {
            this._dispatcher.add(type, fn);
            this._setActive(true);
        } else callSubscriber(type, fn, {
            type: END
        });
        return this;
    },
    _off: function(type, fn) {
        if (this._alive) {
            var count = this._dispatcher.remove(type, fn);
            if (count === 0) this._setActive(false);
        }
        return this;
    },
    onValue: function(fn) {
        return this._on(VALUE, fn);
    },
    onError: function(fn) {
        return this._on(ERROR, fn);
    },
    onEnd: function(fn) {
        return this._on(END, fn);
    },
    onAny: function(fn) {
        return this._on(ANY, fn);
    },
    offValue: function(fn) {
        return this._off(VALUE, fn);
    },
    offError: function(fn) {
        return this._off(ERROR, fn);
    },
    offEnd: function(fn) {
        return this._off(END, fn);
    },
    offAny: function(fn) {
        return this._off(ANY, fn);
    },
    observe: function(observerOrOnValue, onError, onEnd) {
        var _this = this;
        var closed = false;
        var observer = !observerOrOnValue || typeof observerOrOnValue === "function" ? {
            value: observerOrOnValue,
            error: onError,
            end: onEnd
        } : observerOrOnValue;
        var handler = function(event) {
            if (event.type === END) closed = true;
            if (event.type === VALUE && observer.value) observer.value(event.value);
            else if (event.type === ERROR && observer.error) observer.error(event.value);
            else if (event.type === END && observer.end) observer.end(event.value);
        };
        this.onAny(handler);
        return {
            unsubscribe: function() {
                if (!closed) {
                    _this.offAny(handler);
                    closed = true;
                }
            },
            get closed () {
                return closed;
            }
        };
    },
    // A and B must be subclasses of Stream and Property (order doesn't matter)
    _ofSameType: function(A, B) {
        return A.prototype.getType() === this.getType() ? A : B;
    },
    setName: function(sourceObs /* optional */ , selfName) {
        this._name = selfName ? sourceObs._name + "." + selfName : sourceObs;
        return this;
    },
    log: function() {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.toString();
        var isCurrent = void 0;
        var handler = function(event) {
            var type = "<" + event.type + (isCurrent ? ":current" : "") + ">";
            if (event.type === END) console.log(name, type);
            else console.log(name, type, event.value);
        };
        if (this._alive) {
            if (!this._logHandlers) this._logHandlers = [];
            this._logHandlers.push({
                name: name,
                handler: handler
            });
        }
        isCurrent = true;
        this.onAny(handler);
        isCurrent = false;
        return this;
    },
    offLog: function() {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.toString();
        if (this._logHandlers) {
            var handlerIndex = findByPred(this._logHandlers, function(obj) {
                return obj.name === name;
            });
            if (handlerIndex !== -1) {
                this.offAny(this._logHandlers[handlerIndex].handler);
                this._logHandlers.splice(handlerIndex, 1);
            }
        }
        return this;
    },
    spy: function() {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.toString();
        var handler = function(event) {
            var type = "<" + event.type + ">";
            if (event.type === END) console.log(name, type);
            else console.log(name, type, event.value);
        };
        if (this._alive) {
            if (!this._spyHandlers) this._spyHandlers = [];
            this._spyHandlers.push({
                name: name,
                handler: handler
            });
            this._dispatcher.addSpy(handler);
        }
        return this;
    },
    offSpy: function() {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.toString();
        if (this._spyHandlers) {
            var handlerIndex = findByPred(this._spyHandlers, function(obj) {
                return obj.name === name;
            });
            if (handlerIndex !== -1) {
                this._dispatcher.removeSpy(this._spyHandlers[handlerIndex].handler);
                this._spyHandlers.splice(handlerIndex, 1);
            }
        }
        return this;
    }
});
// extend() can't handle `toString` in IE8
Observable.prototype.toString = function() {
    return "[" + this._name + "]";
};
function Stream() {
    Observable.call(this);
}
inherit(Stream, Observable, {
    _name: "stream",
    getType: function() {
        return "stream";
    }
});
function Property() {
    Observable.call(this);
    this._currentEvent = null;
}
inherit(Property, Observable, {
    _name: "property",
    _emitValue: function(value) {
        if (this._alive) {
            this._currentEvent = {
                type: VALUE,
                value: value
            };
            if (!this._activating) this._dispatcher.dispatch({
                type: VALUE,
                value: value
            });
        }
    },
    _emitError: function(value) {
        if (this._alive) {
            this._currentEvent = {
                type: ERROR,
                value: value
            };
            if (!this._activating) this._dispatcher.dispatch({
                type: ERROR,
                value: value
            });
        }
    },
    _emitEnd: function() {
        if (this._alive) {
            this._alive = false;
            if (!this._activating) this._dispatcher.dispatch({
                type: END
            });
            this._clear();
        }
    },
    _on: function(type, fn) {
        if (this._alive) {
            this._dispatcher.add(type, fn);
            this._setActive(true);
        }
        if (this._currentEvent !== null) callSubscriber(type, fn, this._currentEvent);
        if (!this._alive) callSubscriber(type, fn, {
            type: END
        });
        return this;
    },
    getType: function() {
        return "property";
    }
});
var neverS = new Stream();
neverS._emitEnd();
neverS._name = "never";
function never() {
    return neverS;
}
function timeBased(mixin) {
    function AnonymousStream(wait, options) {
        var _this = this;
        Stream.call(this);
        this._wait = wait;
        this._intervalId = null;
        this._$onTick = function() {
            return _this._onTick();
        };
        this._init(options);
    }
    inherit(AnonymousStream, Stream, {
        _init: function() {},
        _free: function() {},
        _onTick: function() {},
        _onActivation: function() {
            this._intervalId = setInterval(this._$onTick, this._wait);
        },
        _onDeactivation: function() {
            if (this._intervalId !== null) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        },
        _clear: function() {
            Stream.prototype._clear.call(this);
            this._$onTick = null;
            this._free();
        }
    }, mixin);
    return AnonymousStream;
}
var S = timeBased({
    _name: "later",
    _init: function(_ref) {
        var x = _ref.x;
        this._x = x;
    },
    _free: function() {
        this._x = null;
    },
    _onTick: function() {
        this._emitValue(this._x);
        this._emitEnd();
    }
});
function later(wait, x) {
    return new S(wait, {
        x: x
    });
}
var S$1 = timeBased({
    _name: "interval",
    _init: function(_ref) {
        var x = _ref.x;
        this._x = x;
    },
    _free: function() {
        this._x = null;
    },
    _onTick: function() {
        this._emitValue(this._x);
    }
});
function interval(wait, x) {
    return new S$1(wait, {
        x: x
    });
}
var S$2 = timeBased({
    _name: "sequentially",
    _init: function(_ref) {
        var xs = _ref.xs;
        this._xs = cloneArray(xs);
    },
    _free: function() {
        this._xs = null;
    },
    _onTick: function() {
        if (this._xs.length === 1) {
            this._emitValue(this._xs[0]);
            this._emitEnd();
        } else this._emitValue(this._xs.shift());
    }
});
function sequentially(wait, xs) {
    return xs.length === 0 ? never() : new S$2(wait, {
        xs: xs
    });
}
var S$3 = timeBased({
    _name: "fromPoll",
    _init: function(_ref) {
        var fn = _ref.fn;
        this._fn = fn;
    },
    _free: function() {
        this._fn = null;
    },
    _onTick: function() {
        var fn = this._fn;
        this._emitValue(fn());
    }
});
function fromPoll(wait, fn) {
    return new S$3(wait, {
        fn: fn
    });
}
function emitter(obs) {
    function value(x) {
        obs._emitValue(x);
        return obs._active;
    }
    function error(x) {
        obs._emitError(x);
        return obs._active;
    }
    function end() {
        obs._emitEnd();
        return obs._active;
    }
    function event(e) {
        obs._emit(e.type, e.value);
        return obs._active;
    }
    return {
        value: value,
        error: error,
        end: end,
        event: event,
        // legacy
        emit: value,
        emitEvent: event
    };
}
var S$4 = timeBased({
    _name: "withInterval",
    _init: function(_ref) {
        var fn = _ref.fn;
        this._fn = fn;
        this._emitter = emitter(this);
    },
    _free: function() {
        this._fn = null;
        this._emitter = null;
    },
    _onTick: function() {
        var fn = this._fn;
        fn(this._emitter);
    }
});
function withInterval(wait, fn) {
    return new S$4(wait, {
        fn: fn
    });
}
function S$5(fn) {
    Stream.call(this);
    this._fn = fn;
    this._unsubscribe = null;
}
inherit(S$5, Stream, {
    _name: "stream",
    _onActivation: function() {
        var fn = this._fn;
        var unsubscribe = fn(emitter(this));
        this._unsubscribe = typeof unsubscribe === "function" ? unsubscribe : null;
        // fix https://github.com/kefirjs/kefir/issues/35
        if (!this._active) this._callUnsubscribe();
    },
    _callUnsubscribe: function() {
        if (this._unsubscribe !== null) {
            this._unsubscribe();
            this._unsubscribe = null;
        }
    },
    _onDeactivation: function() {
        this._callUnsubscribe();
    },
    _clear: function() {
        Stream.prototype._clear.call(this);
        this._fn = null;
    }
});
function stream(fn) {
    return new S$5(fn);
}
function fromCallback(callbackConsumer) {
    var called = false;
    return stream(function(emitter) {
        if (!called) {
            callbackConsumer(function(x) {
                emitter.emit(x);
                emitter.end();
            });
            called = true;
        }
    }).setName("fromCallback");
}
function fromNodeCallback(callbackConsumer) {
    var called = false;
    return stream(function(emitter) {
        if (!called) {
            callbackConsumer(function(error, x) {
                if (error) emitter.error(error);
                else emitter.emit(x);
                emitter.end();
            });
            called = true;
        }
    }).setName("fromNodeCallback");
}
function spread(fn, length) {
    switch(length){
        case 0:
            return function() {
                return fn();
            };
        case 1:
            return function(a) {
                return fn(a[0]);
            };
        case 2:
            return function(a) {
                return fn(a[0], a[1]);
            };
        case 3:
            return function(a) {
                return fn(a[0], a[1], a[2]);
            };
        case 4:
            return function(a) {
                return fn(a[0], a[1], a[2], a[3]);
            };
        default:
            return function(a) {
                return fn.apply(null, a);
            };
    }
}
function apply(fn, c, a) {
    var aLength = a ? a.length : 0;
    if (c == null) switch(aLength){
        case 0:
            return fn();
        case 1:
            return fn(a[0]);
        case 2:
            return fn(a[0], a[1]);
        case 3:
            return fn(a[0], a[1], a[2]);
        case 4:
            return fn(a[0], a[1], a[2], a[3]);
        default:
            return fn.apply(null, a);
    }
    else switch(aLength){
        case 0:
            return fn.call(c);
        default:
            return fn.apply(c, a);
    }
}
function fromSubUnsub(sub, unsub, transformer /* Function | falsey */ ) {
    return stream(function(emitter) {
        var handler = transformer ? function() {
            emitter.emit(apply(transformer, this, arguments));
        } : function(x) {
            emitter.emit(x);
        };
        sub(handler);
        return function() {
            return unsub(handler);
        };
    }).setName("fromSubUnsub");
}
var pairs = [
    [
        "addEventListener",
        "removeEventListener"
    ],
    [
        "addListener",
        "removeListener"
    ],
    [
        "on",
        "off"
    ]
];
function fromEvents(target, eventName, transformer) {
    var sub = void 0, unsub = void 0;
    for(var i = 0; i < pairs.length; i++)if (typeof target[pairs[i][0]] === "function" && typeof target[pairs[i][1]] === "function") {
        sub = pairs[i][0];
        unsub = pairs[i][1];
        break;
    }
    if (sub === undefined) throw new Error("target don't support any of addEventListener/removeEventListener, addListener/removeListener, on/off method pair");
    return fromSubUnsub(function(handler) {
        return target[sub](eventName, handler);
    }, function(handler) {
        return target[unsub](eventName, handler);
    }, transformer).setName("fromEvents");
}
// HACK:
//   We don't call parent Class constructor, but instead putting all necessary
//   properties into prototype to simulate ended Property
//   (see Propperty and Observable classes).
function P(value) {
    this._currentEvent = {
        type: "value",
        value: value,
        current: true
    };
}
inherit(P, Property, {
    _name: "constant",
    _active: false,
    _activating: false,
    _alive: false,
    _dispatcher: null,
    _logHandlers: null
});
function constant(x) {
    return new P(x);
}
// HACK:
//   We don't call parent Class constructor, but instead putting all necessary
//   properties into prototype to simulate ended Property
//   (see Propperty and Observable classes).
function P$1(value) {
    this._currentEvent = {
        type: "error",
        value: value,
        current: true
    };
}
inherit(P$1, Property, {
    _name: "constantError",
    _active: false,
    _activating: false,
    _alive: false,
    _dispatcher: null,
    _logHandlers: null
});
function constantError(x) {
    return new P$1(x);
}
function createConstructor(BaseClass, name) {
    return function AnonymousObservable(source, options) {
        var _this = this;
        BaseClass.call(this);
        this._source = source;
        this._name = source._name + "." + name;
        this._init(options);
        this._$handleAny = function(event) {
            return _this._handleAny(event);
        };
    };
}
function createClassMethods(BaseClass) {
    return {
        _init: function() {},
        _free: function() {},
        _handleValue: function(x) {
            this._emitValue(x);
        },
        _handleError: function(x) {
            this._emitError(x);
        },
        _handleEnd: function() {
            this._emitEnd();
        },
        _handleAny: function(event) {
            switch(event.type){
                case VALUE:
                    return this._handleValue(event.value);
                case ERROR:
                    return this._handleError(event.value);
                case END:
                    return this._handleEnd();
            }
        },
        _onActivation: function() {
            this._source.onAny(this._$handleAny);
        },
        _onDeactivation: function() {
            this._source.offAny(this._$handleAny);
        },
        _clear: function() {
            BaseClass.prototype._clear.call(this);
            this._source = null;
            this._$handleAny = null;
            this._free();
        }
    };
}
function createStream(name, mixin) {
    var S = createConstructor(Stream, name);
    inherit(S, Stream, createClassMethods(Stream), mixin);
    return S;
}
function createProperty(name, mixin) {
    var P = createConstructor(Property, name);
    inherit(P, Property, createClassMethods(Property), mixin);
    return P;
}
var P$2 = createProperty("toProperty", {
    _init: function(_ref) {
        var fn = _ref.fn;
        this._getInitialCurrent = fn;
    },
    _onActivation: function() {
        if (this._getInitialCurrent !== null) {
            var getInitial = this._getInitialCurrent;
            this._emitValue(getInitial());
        }
        this._source.onAny(this._$handleAny); // copied from patterns/one-source
    }
});
function toProperty(obs) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (fn !== null && typeof fn !== "function") throw new Error("You should call toProperty() with a function or no arguments.");
    return new P$2(obs, {
        fn: fn
    });
}
var S$6 = createStream("changes", {
    _handleValue: function(x) {
        if (!this._activating) this._emitValue(x);
    },
    _handleError: function(x) {
        if (!this._activating) this._emitError(x);
    }
});
function changes(obs) {
    return new S$6(obs);
}
function fromPromise(promise) {
    var called = false;
    var result = stream(function(emitter) {
        if (!called) {
            var onValue = function(x) {
                emitter.emit(x);
                emitter.end();
            };
            var onError = function(x) {
                emitter.error(x);
                emitter.end();
            };
            var _promise = promise.then(onValue, onError);
            // prevent libraries like 'Q' or 'when' from swallowing exceptions
            if (_promise && typeof _promise.done === "function") _promise.done();
            called = true;
        }
    });
    return toProperty(result, null).setName("fromPromise");
}
function getGlodalPromise() {
    if (typeof Promise === "function") return Promise;
    else throw new Error("There isn't default Promise, use shim or parameter");
}
var toPromise = function(obs) {
    var Promise1 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getGlodalPromise();
    var last = null;
    return new Promise1(function(resolve, reject) {
        obs.onAny(function(event) {
            if (event.type === END && last !== null) {
                (last.type === VALUE ? resolve : reject)(last.value);
                last = null;
            } else last = event;
        });
    });
};
function symbolObservablePonyfill(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol("observable");
            Symbol.observable = result;
        }
    } else result = "@@observable";
    return result;
}
/* global window */ var root;
if (typeof self !== "undefined") root = self;
else if (typeof window !== "undefined") root = window;
else if (typeof $parcel$global !== "undefined") root = $parcel$global;
else root = module;
var result = symbolObservablePonyfill(root);
// this file contains some hot JS modules systems stuff
var $$observable = result.default ? result.default : result;
function fromESObservable(_observable) {
    var observable = _observable[$$observable] ? _observable[$$observable]() : _observable;
    return stream(function(emitter) {
        var unsub = observable.subscribe({
            error: function(error) {
                emitter.error(error);
                emitter.end();
            },
            next: function(value) {
                emitter.emit(value);
            },
            complete: function() {
                emitter.end();
            }
        });
        if (unsub.unsubscribe) return function() {
            unsub.unsubscribe();
        };
        else return unsub;
    }).setName("fromESObservable");
}
function ESObservable(observable) {
    this._observable = observable.takeErrors(1);
}
extend(ESObservable.prototype, {
    subscribe: function(observerOrOnNext, onError, onComplete) {
        var _this = this;
        var observer = typeof observerOrOnNext === "function" ? {
            next: observerOrOnNext,
            error: onError,
            complete: onComplete
        } : observerOrOnNext;
        var fn = function(event) {
            if (event.type === END) closed = true;
            if (event.type === VALUE && observer.next) observer.next(event.value);
            else if (event.type === ERROR && observer.error) observer.error(event.value);
            else if (event.type === END && observer.complete) observer.complete(event.value);
        };
        this._observable.onAny(fn);
        var closed = false;
        var subscription = {
            unsubscribe: function() {
                closed = true;
                _this._observable.offAny(fn);
            },
            get closed () {
                return closed;
            }
        };
        return subscription;
    }
});
// Need to assign directly b/c Symbols aren't enumerable.
ESObservable.prototype[$$observable] = function() {
    return this;
};
function toESObservable() {
    return new ESObservable(this);
}
function collect(source, keys, values) {
    for(var prop in source)if (source.hasOwnProperty(prop)) {
        keys.push(prop);
        values.push(source[prop]);
    }
}
function defaultErrorsCombinator(errors) {
    var latestError = void 0;
    for(var i = 0; i < errors.length; i++){
        if (errors[i] !== undefined) {
            if (latestError === undefined || latestError.index < errors[i].index) latestError = errors[i];
        }
    }
    return latestError.error;
}
function Combine(active, passive, combinator) {
    var _this = this;
    Stream.call(this);
    this._activeCount = active.length;
    this._sources = concat(active, passive);
    this._combinator = combinator;
    this._aliveCount = 0;
    this._latestValues = new Array(this._sources.length);
    this._latestErrors = new Array(this._sources.length);
    fillArray(this._latestValues, NOTHING);
    this._emitAfterActivation = false;
    this._endAfterActivation = false;
    this._latestErrorIndex = 0;
    this._$handlers = [];
    var _loop = function(i) {
        _this._$handlers.push(function(event) {
            return _this._handleAny(i, event);
        });
    };
    for(var i = 0; i < this._sources.length; i++)_loop(i);
}
inherit(Combine, Stream, {
    _name: "combine",
    _onActivation: function() {
        this._aliveCount = this._activeCount;
        // we need to suscribe to _passive_ sources before _active_
        // (see https://github.com/kefirjs/kefir/issues/98)
        for(var i = this._activeCount; i < this._sources.length; i++)this._sources[i].onAny(this._$handlers[i]);
        for(var _i = 0; _i < this._activeCount; _i++)this._sources[_i].onAny(this._$handlers[_i]);
        if (this._emitAfterActivation) {
            this._emitAfterActivation = false;
            this._emitIfFull();
        }
        if (this._endAfterActivation) this._emitEnd();
    },
    _onDeactivation: function() {
        var length = this._sources.length, i = void 0;
        for(i = 0; i < length; i++)this._sources[i].offAny(this._$handlers[i]);
    },
    _emitIfFull: function() {
        var hasAllValues = true;
        var hasErrors = false;
        var length = this._latestValues.length;
        var valuesCopy = new Array(length);
        var errorsCopy = new Array(length);
        for(var i = 0; i < length; i++){
            valuesCopy[i] = this._latestValues[i];
            errorsCopy[i] = this._latestErrors[i];
            if (valuesCopy[i] === NOTHING) hasAllValues = false;
            if (errorsCopy[i] !== undefined) hasErrors = true;
        }
        if (hasAllValues) {
            var combinator = this._combinator;
            this._emitValue(combinator(valuesCopy));
        }
        if (hasErrors) this._emitError(defaultErrorsCombinator(errorsCopy));
    },
    _handleAny: function(i, event) {
        if (event.type === VALUE || event.type === ERROR) {
            if (event.type === VALUE) {
                this._latestValues[i] = event.value;
                this._latestErrors[i] = undefined;
            }
            if (event.type === ERROR) {
                this._latestValues[i] = NOTHING;
                this._latestErrors[i] = {
                    index: this._latestErrorIndex++,
                    error: event.value
                };
            }
            if (i < this._activeCount) {
                if (this._activating) this._emitAfterActivation = true;
                else this._emitIfFull();
            }
        } else // END
        if (i < this._activeCount) {
            this._aliveCount--;
            if (this._aliveCount === 0) {
                if (this._activating) this._endAfterActivation = true;
                else this._emitEnd();
            }
        }
    },
    _clear: function() {
        Stream.prototype._clear.call(this);
        this._sources = null;
        this._latestValues = null;
        this._latestErrors = null;
        this._combinator = null;
        this._$handlers = null;
    }
});
function combineAsArray(active) {
    var passive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var combinator = arguments[2];
    if (!Array.isArray(passive)) throw new Error("Combine can only combine active and passive collections of the same type.");
    combinator = combinator ? spread(combinator, active.length + passive.length) : function(x) {
        return x;
    };
    return active.length === 0 ? never() : new Combine(active, passive, combinator);
}
function combineAsObject(active) {
    var passive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var combinator = arguments[2];
    if (typeof passive !== "object" || Array.isArray(passive)) throw new Error("Combine can only combine active and passive collections of the same type.");
    var keys = [], activeObservables = [], passiveObservables = [];
    collect(active, keys, activeObservables);
    collect(passive, keys, passiveObservables);
    var objectify = function(values) {
        var event = {};
        for(var i = values.length - 1; 0 <= i; i--)event[keys[i]] = values[i];
        return combinator ? combinator(event) : event;
    };
    return activeObservables.length === 0 ? never() : new Combine(activeObservables, passiveObservables, objectify);
}
function combine(active, passive, combinator) {
    if (typeof passive === "function") {
        combinator = passive;
        passive = undefined;
    }
    return Array.isArray(active) ? combineAsArray(active, passive, combinator) : combineAsObject(active, passive, combinator);
}
var Observable$2 = {
    empty: function() {
        return never();
    },
    // Monoid based on merge() seems more useful than one based on concat().
    concat: function(a, b) {
        return a.merge(b);
    },
    of: function(x) {
        return constant(x);
    },
    map: function(fn, obs) {
        return obs.map(fn);
    },
    bimap: function(fnErr, fnVal, obs) {
        return obs.mapErrors(fnErr).map(fnVal);
    },
    // This ap strictly speaking incompatible with chain. If we derive ap from chain we get
    // different (not very useful) behavior. But spec requires that if method can be derived
    // it must have the same behavior as hand-written method. We intentionally violate the spec
    // in hope that it won't cause many troubles in practice. And in return we have more useful type.
    ap: function(obsFn, obsVal) {
        return combine([
            obsFn,
            obsVal
        ], function(fn, val) {
            return fn(val);
        });
    },
    chain: function(fn, obs) {
        return obs.flatMap(fn);
    }
};
var staticLand = Object.freeze({
    Observable: Observable$2
});
var mixin = {
    _init: function(_ref) {
        var fn = _ref.fn;
        this._fn = fn;
    },
    _free: function() {
        this._fn = null;
    },
    _handleValue: function(x) {
        var fn = this._fn;
        this._emitValue(fn(x));
    }
};
var S$7 = createStream("map", mixin);
var P$3 = createProperty("map", mixin);
var id = function(x) {
    return x;
};
function map$1(obs) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : id;
    return new (obs._ofSameType(S$7, P$3))(obs, {
        fn: fn
    });
}
var mixin$1 = {
    _init: function(_ref) {
        var fn = _ref.fn;
        this._fn = fn;
    },
    _free: function() {
        this._fn = null;
    },
    _handleValue: function(x) {
        var fn = this._fn;
        if (fn(x)) this._emitValue(x);
    }
};
var S$8 = createStream("filter", mixin$1);
var P$4 = createProperty("filter", mixin$1);
var id$1 = function(x) {
    return x;
};
function filter(obs) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : id$1;
    return new (obs._ofSameType(S$8, P$4))(obs, {
        fn: fn
    });
}
var mixin$2 = {
    _init: function(_ref) {
        var n = _ref.n;
        this._n = n;
        if (n <= 0) this._emitEnd();
    },
    _handleValue: function(x) {
        if (this._n === 0) return;
        this._n--;
        this._emitValue(x);
        if (this._n === 0) this._emitEnd();
    }
};
var S$9 = createStream("take", mixin$2);
var P$5 = createProperty("take", mixin$2);
function take(obs, n) {
    return new (obs._ofSameType(S$9, P$5))(obs, {
        n: n
    });
}
var mixin$3 = {
    _init: function(_ref) {
        var n = _ref.n;
        this._n = n;
        if (n <= 0) this._emitEnd();
    },
    _handleError: function(x) {
        if (this._n === 0) return;
        this._n--;
        this._emitError(x);
        if (this._n === 0) this._emitEnd();
    }
};
var S$10 = createStream("takeErrors", mixin$3);
var P$6 = createProperty("takeErrors", mixin$3);
function takeErrors(obs, n) {
    return new (obs._ofSameType(S$10, P$6))(obs, {
        n: n
    });
}
var mixin$4 = {
    _init: function(_ref) {
        var fn = _ref.fn;
        this._fn = fn;
    },
    _free: function() {
        this._fn = null;
    },
    _handleValue: function(x) {
        var fn = this._fn;
        if (fn(x)) this._emitValue(x);
        else this._emitEnd();
    }
};
var S$11 = createStream("takeWhile", mixin$4);
var P$7 = createProperty("takeWhile", mixin$4);
var id$2 = function(x) {
    return x;
};
function takeWhile(obs) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : id$2;
    return new (obs._ofSameType(S$11, P$7))(obs, {
        fn: fn
    });
}
var mixin$5 = {
    _init: function() {
        this._lastValue = NOTHING;
    },
    _free: function() {
        this._lastValue = null;
    },
    _handleValue: function(x) {
        this._lastValue = x;
    },
    _handleEnd: function() {
        if (this._lastValue !== NOTHING) this._emitValue(this._lastValue);
        this._emitEnd();
    }
};
var S$12 = createStream("last", mixin$5);
var P$8 = createProperty("last", mixin$5);
function last(obs) {
    return new (obs._ofSameType(S$12, P$8))(obs);
}
var mixin$6 = {
    _init: function(_ref) {
        var n = _ref.n;
        this._n = Math.max(0, n);
    },
    _handleValue: function(x) {
        if (this._n === 0) this._emitValue(x);
        else this._n--;
    }
};
var S$13 = createStream("skip", mixin$6);
var P$9 = createProperty("skip", mixin$6);
function skip(obs, n) {
    return new (obs._ofSameType(S$13, P$9))(obs, {
        n: n
    });
}
var mixin$7 = {
    _init: function(_ref) {
        var fn = _ref.fn;
        this._fn = fn;
    },
    _free: function() {
        this._fn = null;
    },
    _handleValue: function(x) {
        var fn = this._fn;
        if (this._fn !== null && !fn(x)) this._fn = null;
        if (this._fn === null) this._emitValue(x);
    }
};
var S$14 = createStream("skipWhile", mixin$7);
var P$10 = createProperty("skipWhile", mixin$7);
var id$3 = function(x) {
    return x;
};
function skipWhile(obs) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : id$3;
    return new (obs._ofSameType(S$14, P$10))(obs, {
        fn: fn
    });
}
var mixin$8 = {
    _init: function(_ref) {
        var fn = _ref.fn;
        this._fn = fn;
        this._prev = NOTHING;
    },
    _free: function() {
        this._fn = null;
        this._prev = null;
    },
    _handleValue: function(x) {
        var fn = this._fn;
        if (this._prev === NOTHING || !fn(this._prev, x)) {
            this._prev = x;
            this._emitValue(x);
        }
    }
};
var S$15 = createStream("skipDuplicates", mixin$8);
var P$11 = createProperty("skipDuplicates", mixin$8);
var eq = function(a, b) {
    return a === b;
};
function skipDuplicates(obs) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : eq;
    return new (obs._ofSameType(S$15, P$11))(obs, {
        fn: fn
    });
}
var mixin$9 = {
    _init: function(_ref) {
        var fn = _ref.fn, seed = _ref.seed;
        this._fn = fn;
        this._prev = seed;
    },
    _free: function() {
        this._prev = null;
        this._fn = null;
    },
    _handleValue: function(x) {
        if (this._prev !== NOTHING) {
            var fn = this._fn;
            this._emitValue(fn(this._prev, x));
        }
        this._prev = x;
    }
};
var S$16 = createStream("diff", mixin$9);
var P$12 = createProperty("diff", mixin$9);
function defaultFn(a, b) {
    return [
        a,
        b
    ];
}
function diff(obs, fn) {
    var seed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : NOTHING;
    return new (obs._ofSameType(S$16, P$12))(obs, {
        fn: fn || defaultFn,
        seed: seed
    });
}
var P$13 = createProperty("scan", {
    _init: function(_ref) {
        var fn = _ref.fn, seed = _ref.seed;
        this._fn = fn;
        this._seed = seed;
        if (seed !== NOTHING) this._emitValue(seed);
    },
    _free: function() {
        this._fn = null;
        this._seed = null;
    },
    _handleValue: function(x) {
        var fn = this._fn;
        if (this._currentEvent === null || this._currentEvent.type === ERROR) this._emitValue(this._seed === NOTHING ? x : fn(this._seed, x));
        else this._emitValue(fn(this._currentEvent.value, x));
    }
});
function scan(obs, fn) {
    var seed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : NOTHING;
    return new P$13(obs, {
        fn: fn,
        seed: seed
    });
}
var mixin$10 = {
    _init: function(_ref) {
        var fn = _ref.fn;
        this._fn = fn;
    },
    _free: function() {
        this._fn = null;
    },
    _handleValue: function(x) {
        var fn = this._fn;
        var xs = fn(x);
        for(var i = 0; i < xs.length; i++)this._emitValue(xs[i]);
    }
};
var S$17 = createStream("flatten", mixin$10);
var id$4 = function(x) {
    return x;
};
function flatten(obs) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : id$4;
    return new S$17(obs, {
        fn: fn
    });
}
var END_MARKER = {};
var mixin$11 = {
    _init: function(_ref) {
        var _this = this;
        var wait = _ref.wait;
        this._wait = Math.max(0, wait);
        this._buff = [];
        this._$shiftBuff = function() {
            var value = _this._buff.shift();
            if (value === END_MARKER) _this._emitEnd();
            else _this._emitValue(value);
        };
    },
    _free: function() {
        this._buff = null;
        this._$shiftBuff = null;
    },
    _handleValue: function(x) {
        if (this._activating) this._emitValue(x);
        else {
            this._buff.push(x);
            setTimeout(this._$shiftBuff, this._wait);
        }
    },
    _handleEnd: function() {
        if (this._activating) this._emitEnd();
        else {
            this._buff.push(END_MARKER);
            setTimeout(this._$shiftBuff, this._wait);
        }
    }
};
var S$18 = createStream("delay", mixin$11);
var P$14 = createProperty("delay", mixin$11);
function delay(obs, wait) {
    return new (obs._ofSameType(S$18, P$14))(obs, {
        wait: wait
    });
}
var now = Date.now ? function() {
    return Date.now();
} : function() {
    return new Date().getTime();
};
var mixin$12 = {
    _init: function(_ref) {
        var _this = this;
        var wait = _ref.wait, leading = _ref.leading, trailing = _ref.trailing;
        this._wait = Math.max(0, wait);
        this._leading = leading;
        this._trailing = trailing;
        this._trailingValue = null;
        this._timeoutId = null;
        this._endLater = false;
        this._lastCallTime = 0;
        this._$trailingCall = function() {
            return _this._trailingCall();
        };
    },
    _free: function() {
        this._trailingValue = null;
        this._$trailingCall = null;
    },
    _handleValue: function(x) {
        if (this._activating) this._emitValue(x);
        else {
            var curTime = now();
            if (this._lastCallTime === 0 && !this._leading) this._lastCallTime = curTime;
            var remaining = this._wait - (curTime - this._lastCallTime);
            if (remaining <= 0) {
                this._cancelTrailing();
                this._lastCallTime = curTime;
                this._emitValue(x);
            } else if (this._trailing) {
                this._cancelTrailing();
                this._trailingValue = x;
                this._timeoutId = setTimeout(this._$trailingCall, remaining);
            }
        }
    },
    _handleEnd: function() {
        if (this._activating) this._emitEnd();
        else if (this._timeoutId) this._endLater = true;
        else this._emitEnd();
    },
    _cancelTrailing: function() {
        if (this._timeoutId !== null) {
            clearTimeout(this._timeoutId);
            this._timeoutId = null;
        }
    },
    _trailingCall: function() {
        this._emitValue(this._trailingValue);
        this._timeoutId = null;
        this._trailingValue = null;
        this._lastCallTime = !this._leading ? 0 : now();
        if (this._endLater) this._emitEnd();
    }
};
var S$19 = createStream("throttle", mixin$12);
var P$15 = createProperty("throttle", mixin$12);
function throttle(obs, wait) {
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref2$leading = _ref2.leading, leading = _ref2$leading === undefined ? true : _ref2$leading, _ref2$trailing = _ref2.trailing, trailing = _ref2$trailing === undefined ? true : _ref2$trailing;
    return new (obs._ofSameType(S$19, P$15))(obs, {
        wait: wait,
        leading: leading,
        trailing: trailing
    });
}
var mixin$13 = {
    _init: function(_ref) {
        var _this = this;
        var wait = _ref.wait, immediate = _ref.immediate;
        this._wait = Math.max(0, wait);
        this._immediate = immediate;
        this._lastAttempt = 0;
        this._timeoutId = null;
        this._laterValue = null;
        this._endLater = false;
        this._$later = function() {
            return _this._later();
        };
    },
    _free: function() {
        this._laterValue = null;
        this._$later = null;
    },
    _handleValue: function(x) {
        if (this._activating) this._emitValue(x);
        else {
            this._lastAttempt = now();
            if (this._immediate && !this._timeoutId) this._emitValue(x);
            if (!this._timeoutId) this._timeoutId = setTimeout(this._$later, this._wait);
            if (!this._immediate) this._laterValue = x;
        }
    },
    _handleEnd: function() {
        if (this._activating) this._emitEnd();
        else if (this._timeoutId && !this._immediate) this._endLater = true;
        else this._emitEnd();
    },
    _later: function() {
        var last = now() - this._lastAttempt;
        if (last < this._wait && last >= 0) this._timeoutId = setTimeout(this._$later, this._wait - last);
        else {
            this._timeoutId = null;
            if (!this._immediate) {
                var _laterValue = this._laterValue;
                this._laterValue = null;
                this._emitValue(_laterValue);
            }
            if (this._endLater) this._emitEnd();
        }
    }
};
var S$20 = createStream("debounce", mixin$13);
var P$16 = createProperty("debounce", mixin$13);
function debounce(obs, wait) {
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref2$immediate = _ref2.immediate, immediate = _ref2$immediate === undefined ? false : _ref2$immediate;
    return new (obs._ofSameType(S$20, P$16))(obs, {
        wait: wait,
        immediate: immediate
    });
}
var mixin$14 = {
    _init: function(_ref) {
        var fn = _ref.fn;
        this._fn = fn;
    },
    _free: function() {
        this._fn = null;
    },
    _handleError: function(x) {
        var fn = this._fn;
        this._emitError(fn(x));
    }
};
var S$21 = createStream("mapErrors", mixin$14);
var P$17 = createProperty("mapErrors", mixin$14);
var id$5 = function(x) {
    return x;
};
function mapErrors(obs) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : id$5;
    return new (obs._ofSameType(S$21, P$17))(obs, {
        fn: fn
    });
}
var mixin$15 = {
    _init: function(_ref) {
        var fn = _ref.fn;
        this._fn = fn;
    },
    _free: function() {
        this._fn = null;
    },
    _handleError: function(x) {
        var fn = this._fn;
        if (fn(x)) this._emitError(x);
    }
};
var S$22 = createStream("filterErrors", mixin$15);
var P$18 = createProperty("filterErrors", mixin$15);
var id$6 = function(x) {
    return x;
};
function filterErrors(obs) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : id$6;
    return new (obs._ofSameType(S$22, P$18))(obs, {
        fn: fn
    });
}
var mixin$16 = {
    _handleValue: function() {}
};
var S$23 = createStream("ignoreValues", mixin$16);
var P$19 = createProperty("ignoreValues", mixin$16);
function ignoreValues(obs) {
    return new (obs._ofSameType(S$23, P$19))(obs);
}
var mixin$17 = {
    _handleError: function() {}
};
var S$24 = createStream("ignoreErrors", mixin$17);
var P$20 = createProperty("ignoreErrors", mixin$17);
function ignoreErrors(obs) {
    return new (obs._ofSameType(S$24, P$20))(obs);
}
var mixin$18 = {
    _handleEnd: function() {}
};
var S$25 = createStream("ignoreEnd", mixin$18);
var P$21 = createProperty("ignoreEnd", mixin$18);
function ignoreEnd(obs) {
    return new (obs._ofSameType(S$25, P$21))(obs);
}
var mixin$19 = {
    _init: function(_ref) {
        var fn = _ref.fn;
        this._fn = fn;
    },
    _free: function() {
        this._fn = null;
    },
    _handleEnd: function() {
        var fn = this._fn;
        this._emitValue(fn());
        this._emitEnd();
    }
};
var S$26 = createStream("beforeEnd", mixin$19);
var P$22 = createProperty("beforeEnd", mixin$19);
function beforeEnd(obs, fn) {
    return new (obs._ofSameType(S$26, P$22))(obs, {
        fn: fn
    });
}
var mixin$20 = {
    _init: function(_ref) {
        var min = _ref.min, max = _ref.max;
        this._max = max;
        this._min = min;
        this._buff = [];
    },
    _free: function() {
        this._buff = null;
    },
    _handleValue: function(x) {
        this._buff = slide(this._buff, x, this._max);
        if (this._buff.length >= this._min) this._emitValue(this._buff);
    }
};
var S$27 = createStream("slidingWindow", mixin$20);
var P$23 = createProperty("slidingWindow", mixin$20);
function slidingWindow(obs, max) {
    var min = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    return new (obs._ofSameType(S$27, P$23))(obs, {
        min: min,
        max: max
    });
}
var mixin$21 = {
    _init: function(_ref) {
        var fn = _ref.fn, flushOnEnd = _ref.flushOnEnd;
        this._fn = fn;
        this._flushOnEnd = flushOnEnd;
        this._buff = [];
    },
    _free: function() {
        this._buff = null;
    },
    _flush: function() {
        if (this._buff !== null && this._buff.length !== 0) {
            this._emitValue(this._buff);
            this._buff = [];
        }
    },
    _handleValue: function(x) {
        this._buff.push(x);
        var fn = this._fn;
        if (!fn(x)) this._flush();
    },
    _handleEnd: function() {
        if (this._flushOnEnd) this._flush();
        this._emitEnd();
    }
};
var S$28 = createStream("bufferWhile", mixin$21);
var P$24 = createProperty("bufferWhile", mixin$21);
var id$7 = function(x) {
    return x;
};
function bufferWhile(obs, fn) {
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref2$flushOnEnd = _ref2.flushOnEnd, flushOnEnd = _ref2$flushOnEnd === undefined ? true : _ref2$flushOnEnd;
    return new (obs._ofSameType(S$28, P$24))(obs, {
        fn: fn || id$7,
        flushOnEnd: flushOnEnd
    });
}
var mixin$22 = {
    _init: function(_ref) {
        var count = _ref.count, flushOnEnd = _ref.flushOnEnd;
        this._count = count;
        this._flushOnEnd = flushOnEnd;
        this._buff = [];
    },
    _free: function() {
        this._buff = null;
    },
    _flush: function() {
        if (this._buff !== null && this._buff.length !== 0) {
            this._emitValue(this._buff);
            this._buff = [];
        }
    },
    _handleValue: function(x) {
        this._buff.push(x);
        if (this._buff.length >= this._count) this._flush();
    },
    _handleEnd: function() {
        if (this._flushOnEnd) this._flush();
        this._emitEnd();
    }
};
var S$29 = createStream("bufferWithCount", mixin$22);
var P$25 = createProperty("bufferWithCount", mixin$22);
function bufferWhile$1(obs, count) {
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, _ref2$flushOnEnd = _ref2.flushOnEnd, flushOnEnd = _ref2$flushOnEnd === undefined ? true : _ref2$flushOnEnd;
    return new (obs._ofSameType(S$29, P$25))(obs, {
        count: count,
        flushOnEnd: flushOnEnd
    });
}
var mixin$23 = {
    _init: function(_ref) {
        var _this = this;
        var wait = _ref.wait, count = _ref.count, flushOnEnd = _ref.flushOnEnd;
        this._wait = wait;
        this._count = count;
        this._flushOnEnd = flushOnEnd;
        this._intervalId = null;
        this._$onTick = function() {
            return _this._flush();
        };
        this._buff = [];
    },
    _free: function() {
        this._$onTick = null;
        this._buff = null;
    },
    _flush: function() {
        if (this._buff !== null) {
            this._emitValue(this._buff);
            this._buff = [];
        }
    },
    _handleValue: function(x) {
        this._buff.push(x);
        if (this._buff.length >= this._count) {
            clearInterval(this._intervalId);
            this._flush();
            this._intervalId = setInterval(this._$onTick, this._wait);
        }
    },
    _handleEnd: function() {
        if (this._flushOnEnd && this._buff.length !== 0) this._flush();
        this._emitEnd();
    },
    _onActivation: function() {
        this._intervalId = setInterval(this._$onTick, this._wait);
        this._source.onAny(this._$handleAny); // copied from patterns/one-source
    },
    _onDeactivation: function() {
        if (this._intervalId !== null) {
            clearInterval(this._intervalId);
            this._intervalId = null;
        }
        this._source.offAny(this._$handleAny); // copied from patterns/one-source
    }
};
var S$30 = createStream("bufferWithTimeOrCount", mixin$23);
var P$26 = createProperty("bufferWithTimeOrCount", mixin$23);
function bufferWithTimeOrCount(obs, wait, count) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {}, _ref2$flushOnEnd = _ref2.flushOnEnd, flushOnEnd = _ref2$flushOnEnd === undefined ? true : _ref2$flushOnEnd;
    return new (obs._ofSameType(S$30, P$26))(obs, {
        wait: wait,
        count: count,
        flushOnEnd: flushOnEnd
    });
}
function xformForObs(obs) {
    return {
        "@@transducer/step": function(res, input) {
            obs._emitValue(input);
            return null;
        },
        "@@transducer/result": function() {
            obs._emitEnd();
            return null;
        }
    };
}
var mixin$24 = {
    _init: function(_ref) {
        var transducer = _ref.transducer;
        this._xform = transducer(xformForObs(this));
    },
    _free: function() {
        this._xform = null;
    },
    _handleValue: function(x) {
        if (this._xform["@@transducer/step"](null, x) !== null) this._xform["@@transducer/result"](null);
    },
    _handleEnd: function() {
        this._xform["@@transducer/result"](null);
    }
};
var S$31 = createStream("transduce", mixin$24);
var P$27 = createProperty("transduce", mixin$24);
function transduce(obs, transducer) {
    return new (obs._ofSameType(S$31, P$27))(obs, {
        transducer: transducer
    });
}
var mixin$25 = {
    _init: function(_ref) {
        var fn = _ref.fn;
        this._handler = fn;
        this._emitter = emitter(this);
    },
    _free: function() {
        this._handler = null;
        this._emitter = null;
    },
    _handleAny: function(event) {
        this._handler(this._emitter, event);
    }
};
var S$32 = createStream("withHandler", mixin$25);
var P$28 = createProperty("withHandler", mixin$25);
function withHandler(obs, fn) {
    return new (obs._ofSameType(S$32, P$28))(obs, {
        fn: fn
    });
}
var isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};
function Zip(sources, combinator) {
    var _this = this;
    Stream.call(this);
    this._buffers = map(sources, function(source) {
        return isArray(source) ? cloneArray(source) : [];
    });
    this._sources = map(sources, function(source) {
        return isArray(source) ? never() : source;
    });
    this._combinator = combinator ? spread(combinator, this._sources.length) : function(x) {
        return x;
    };
    this._aliveCount = 0;
    this._$handlers = [];
    var _loop = function(i) {
        _this._$handlers.push(function(event) {
            return _this._handleAny(i, event);
        });
    };
    for(var i = 0; i < this._sources.length; i++)_loop(i);
}
inherit(Zip, Stream, {
    _name: "zip",
    _onActivation: function() {
        // if all sources are arrays
        while(this._isFull())this._emit();
        var length = this._sources.length;
        this._aliveCount = length;
        for(var i = 0; i < length && this._active; i++)this._sources[i].onAny(this._$handlers[i]);
    },
    _onDeactivation: function() {
        for(var i = 0; i < this._sources.length; i++)this._sources[i].offAny(this._$handlers[i]);
    },
    _emit: function() {
        var values = new Array(this._buffers.length);
        for(var i = 0; i < this._buffers.length; i++)values[i] = this._buffers[i].shift();
        var combinator = this._combinator;
        this._emitValue(combinator(values));
    },
    _isFull: function() {
        for(var i = 0; i < this._buffers.length; i++){
            if (this._buffers[i].length === 0) return false;
        }
        return true;
    },
    _handleAny: function(i, event) {
        if (event.type === VALUE) {
            this._buffers[i].push(event.value);
            if (this._isFull()) this._emit();
        }
        if (event.type === ERROR) this._emitError(event.value);
        if (event.type === END) {
            this._aliveCount--;
            if (this._aliveCount === 0) this._emitEnd();
        }
    },
    _clear: function() {
        Stream.prototype._clear.call(this);
        this._sources = null;
        this._buffers = null;
        this._combinator = null;
        this._$handlers = null;
    }
});
function zip(observables, combinator /* Function | falsey */ ) {
    return observables.length === 0 ? never() : new Zip(observables, combinator);
}
var id$8 = function(x) {
    return x;
};
function AbstractPool() {
    var _this = this;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$queueLim = _ref.queueLim, queueLim = _ref$queueLim === undefined ? 0 : _ref$queueLim, _ref$concurLim = _ref.concurLim, concurLim = _ref$concurLim === undefined ? -1 : _ref$concurLim, _ref$drop = _ref.drop, drop = _ref$drop === undefined ? "new" : _ref$drop;
    Stream.call(this);
    this._queueLim = queueLim < 0 ? -1 : queueLim;
    this._concurLim = concurLim < 0 ? -1 : concurLim;
    this._drop = drop;
    this._queue = [];
    this._curSources = [];
    this._$handleSubAny = function(event) {
        return _this._handleSubAny(event);
    };
    this._$endHandlers = [];
    this._currentlyAdding = null;
    if (this._concurLim === 0) this._emitEnd();
}
inherit(AbstractPool, Stream, {
    _name: "abstractPool",
    _add: function(obj, toObs /* Function | falsey */ ) {
        toObs = toObs || id$8;
        if (this._concurLim === -1 || this._curSources.length < this._concurLim) this._addToCur(toObs(obj));
        else {
            if (this._queueLim === -1 || this._queue.length < this._queueLim) this._addToQueue(toObs(obj));
            else if (this._drop === "old") {
                this._removeOldest();
                this._add(obj, toObs);
            }
        }
    },
    _addAll: function(obss) {
        var _this2 = this;
        forEach(obss, function(obs) {
            return _this2._add(obs);
        });
    },
    _remove: function(obs) {
        if (this._removeCur(obs) === -1) this._removeQueue(obs);
    },
    _addToQueue: function(obs) {
        this._queue = concat(this._queue, [
            obs
        ]);
    },
    _addToCur: function(obs) {
        if (this._active) {
            // HACK:
            //
            // We have two optimizations for cases when `obs` is ended. We don't want
            // to add such observable to the list, but only want to emit events
            // from it (if it has some).
            //
            // Instead of this hacks, we could just did following,
            // but it would be 5-8 times slower:
            //
            //     this._curSources = concat(this._curSources, [obs]);
            //     this._subscribe(obs);
            //
            // #1
            // This one for cases when `obs` already ended
            // e.g., Kefir.constant() or Kefir.never()
            if (!obs._alive) {
                if (obs._currentEvent) this._emit(obs._currentEvent.type, obs._currentEvent.value);
                // The _emit above could have caused this stream to end.
                if (this._active) {
                    if (this._queue.length !== 0) this._pullQueue();
                    else if (this._curSources.length === 0) this._onEmpty();
                }
                return;
            }
            // #2
            // This one is for cases when `obs` going to end synchronously on
            // first subscriber e.g., Kefir.stream(em => {em.emit(1); em.end()})
            this._currentlyAdding = obs;
            obs.onAny(this._$handleSubAny);
            this._currentlyAdding = null;
            if (obs._alive) {
                this._curSources = concat(this._curSources, [
                    obs
                ]);
                if (this._active) this._subToEnd(obs);
            } else {
                if (this._queue.length !== 0) this._pullQueue();
                else if (this._curSources.length === 0) this._onEmpty();
            }
        } else this._curSources = concat(this._curSources, [
            obs
        ]);
    },
    _subToEnd: function(obs) {
        var _this3 = this;
        var onEnd = function() {
            return _this3._removeCur(obs);
        };
        this._$endHandlers.push({
            obs: obs,
            handler: onEnd
        });
        obs.onEnd(onEnd);
    },
    _subscribe: function(obs) {
        obs.onAny(this._$handleSubAny);
        // it can become inactive in responce of subscribing to `obs.onAny` above
        if (this._active) this._subToEnd(obs);
    },
    _unsubscribe: function(obs) {
        obs.offAny(this._$handleSubAny);
        var onEndI = findByPred(this._$endHandlers, function(obj) {
            return obj.obs === obs;
        });
        if (onEndI !== -1) {
            obs.offEnd(this._$endHandlers[onEndI].handler);
            this._$endHandlers.splice(onEndI, 1);
        }
    },
    _handleSubAny: function(event) {
        if (event.type === VALUE) this._emitValue(event.value);
        else if (event.type === ERROR) this._emitError(event.value);
    },
    _removeQueue: function(obs) {
        var index = find(this._queue, obs);
        this._queue = remove(this._queue, index);
        return index;
    },
    _removeCur: function(obs) {
        if (this._active) this._unsubscribe(obs);
        var index = find(this._curSources, obs);
        this._curSources = remove(this._curSources, index);
        if (index !== -1) {
            if (this._queue.length !== 0) this._pullQueue();
            else if (this._curSources.length === 0) this._onEmpty();
        }
        return index;
    },
    _removeOldest: function() {
        this._removeCur(this._curSources[0]);
    },
    _pullQueue: function() {
        if (this._queue.length !== 0) {
            this._queue = cloneArray(this._queue);
            this._addToCur(this._queue.shift());
        }
    },
    _onActivation: function() {
        for(var i = 0, sources = this._curSources; i < sources.length && this._active; i++)this._subscribe(sources[i]);
    },
    _onDeactivation: function() {
        for(var i = 0, sources = this._curSources; i < sources.length; i++)this._unsubscribe(sources[i]);
        if (this._currentlyAdding !== null) this._unsubscribe(this._currentlyAdding);
    },
    _isEmpty: function() {
        return this._curSources.length === 0;
    },
    _onEmpty: function() {},
    _clear: function() {
        Stream.prototype._clear.call(this);
        this._queue = null;
        this._curSources = null;
        this._$handleSubAny = null;
        this._$endHandlers = null;
    }
});
function Merge(sources) {
    AbstractPool.call(this);
    this._addAll(sources);
    this._initialised = true;
}
inherit(Merge, AbstractPool, {
    _name: "merge",
    _onEmpty: function() {
        if (this._initialised) this._emitEnd();
    }
});
function merge(observables) {
    return observables.length === 0 ? never() : new Merge(observables);
}
function S$33(generator) {
    var _this = this;
    Stream.call(this);
    this._generator = generator;
    this._source = null;
    this._inLoop = false;
    this._iteration = 0;
    this._$handleAny = function(event) {
        return _this._handleAny(event);
    };
}
inherit(S$33, Stream, {
    _name: "repeat",
    _handleAny: function(event) {
        if (event.type === END) {
            this._source = null;
            this._getSource();
        } else this._emit(event.type, event.value);
    },
    _getSource: function() {
        if (!this._inLoop) {
            this._inLoop = true;
            var generator = this._generator;
            while(this._source === null && this._alive && this._active){
                this._source = generator(this._iteration++);
                if (this._source) this._source.onAny(this._$handleAny);
                else this._emitEnd();
            }
            this._inLoop = false;
        }
    },
    _onActivation: function() {
        if (this._source) this._source.onAny(this._$handleAny);
        else this._getSource();
    },
    _onDeactivation: function() {
        if (this._source) this._source.offAny(this._$handleAny);
    },
    _clear: function() {
        Stream.prototype._clear.call(this);
        this._generator = null;
        this._source = null;
        this._$handleAny = null;
    }
});
var repeat = function(generator) {
    return new S$33(generator);
};
function concat$1(observables) {
    return repeat(function(index) {
        return observables.length > index ? observables[index] : false;
    }).setName("concat");
}
function Pool() {
    AbstractPool.call(this);
}
inherit(Pool, AbstractPool, {
    _name: "pool",
    plug: function(obs) {
        this._add(obs);
        return this;
    },
    unplug: function(obs) {
        this._remove(obs);
        return this;
    }
});
function FlatMap(source, fn, options) {
    var _this = this;
    AbstractPool.call(this, options);
    this._source = source;
    this._fn = fn;
    this._mainEnded = false;
    this._lastCurrent = null;
    this._$handleMain = function(event) {
        return _this._handleMain(event);
    };
}
inherit(FlatMap, AbstractPool, {
    _onActivation: function() {
        AbstractPool.prototype._onActivation.call(this);
        if (this._active) this._source.onAny(this._$handleMain);
    },
    _onDeactivation: function() {
        AbstractPool.prototype._onDeactivation.call(this);
        this._source.offAny(this._$handleMain);
        this._hadNoEvSinceDeact = true;
    },
    _handleMain: function(event) {
        if (event.type === VALUE) {
            // Is latest value before deactivation survived, and now is 'current' on this activation?
            // We don't want to handle such values, to prevent to constantly add
            // same observale on each activation/deactivation when our main source
            // is a `Kefir.conatant()` for example.
            var sameCurr = this._activating && this._hadNoEvSinceDeact && this._lastCurrent === event.value;
            if (!sameCurr) this._add(event.value, this._fn);
            this._lastCurrent = event.value;
            this._hadNoEvSinceDeact = false;
        }
        if (event.type === ERROR) this._emitError(event.value);
        if (event.type === END) {
            if (this._isEmpty()) this._emitEnd();
            else this._mainEnded = true;
        }
    },
    _onEmpty: function() {
        if (this._mainEnded) this._emitEnd();
    },
    _clear: function() {
        AbstractPool.prototype._clear.call(this);
        this._source = null;
        this._lastCurrent = null;
        this._$handleMain = null;
    }
});
function FlatMapErrors(source, fn) {
    FlatMap.call(this, source, fn);
}
inherit(FlatMapErrors, FlatMap, {
    // Same as in FlatMap, only VALUE/ERROR flipped
    _handleMain: function(event) {
        if (event.type === ERROR) {
            var sameCurr = this._activating && this._hadNoEvSinceDeact && this._lastCurrent === event.value;
            if (!sameCurr) this._add(event.value, this._fn);
            this._lastCurrent = event.value;
            this._hadNoEvSinceDeact = false;
        }
        if (event.type === VALUE) this._emitValue(event.value);
        if (event.type === END) {
            if (this._isEmpty()) this._emitEnd();
            else this._mainEnded = true;
        }
    }
});
function createConstructor$1(BaseClass, name) {
    return function AnonymousObservable(primary, secondary, options) {
        var _this = this;
        BaseClass.call(this);
        this._primary = primary;
        this._secondary = secondary;
        this._name = primary._name + "." + name;
        this._lastSecondary = NOTHING;
        this._$handleSecondaryAny = function(event) {
            return _this._handleSecondaryAny(event);
        };
        this._$handlePrimaryAny = function(event) {
            return _this._handlePrimaryAny(event);
        };
        this._init(options);
    };
}
function createClassMethods$1(BaseClass) {
    return {
        _init: function() {},
        _free: function() {},
        _handlePrimaryValue: function(x) {
            this._emitValue(x);
        },
        _handlePrimaryError: function(x) {
            this._emitError(x);
        },
        _handlePrimaryEnd: function() {
            this._emitEnd();
        },
        _handleSecondaryValue: function(x) {
            this._lastSecondary = x;
        },
        _handleSecondaryError: function(x) {
            this._emitError(x);
        },
        _handleSecondaryEnd: function() {},
        _handlePrimaryAny: function(event) {
            switch(event.type){
                case VALUE:
                    return this._handlePrimaryValue(event.value);
                case ERROR:
                    return this._handlePrimaryError(event.value);
                case END:
                    return this._handlePrimaryEnd(event.value);
            }
        },
        _handleSecondaryAny: function(event) {
            switch(event.type){
                case VALUE:
                    return this._handleSecondaryValue(event.value);
                case ERROR:
                    return this._handleSecondaryError(event.value);
                case END:
                    this._handleSecondaryEnd(event.value);
                    this._removeSecondary();
            }
        },
        _removeSecondary: function() {
            if (this._secondary !== null) {
                this._secondary.offAny(this._$handleSecondaryAny);
                this._$handleSecondaryAny = null;
                this._secondary = null;
            }
        },
        _onActivation: function() {
            if (this._secondary !== null) this._secondary.onAny(this._$handleSecondaryAny);
            if (this._active) this._primary.onAny(this._$handlePrimaryAny);
        },
        _onDeactivation: function() {
            if (this._secondary !== null) this._secondary.offAny(this._$handleSecondaryAny);
            this._primary.offAny(this._$handlePrimaryAny);
        },
        _clear: function() {
            BaseClass.prototype._clear.call(this);
            this._primary = null;
            this._secondary = null;
            this._lastSecondary = null;
            this._$handleSecondaryAny = null;
            this._$handlePrimaryAny = null;
            this._free();
        }
    };
}
function createStream$1(name, mixin) {
    var S = createConstructor$1(Stream, name);
    inherit(S, Stream, createClassMethods$1(Stream), mixin);
    return S;
}
function createProperty$1(name, mixin) {
    var P = createConstructor$1(Property, name);
    inherit(P, Property, createClassMethods$1(Property), mixin);
    return P;
}
var mixin$26 = {
    _handlePrimaryValue: function(x) {
        if (this._lastSecondary !== NOTHING && this._lastSecondary) this._emitValue(x);
    },
    _handleSecondaryEnd: function() {
        if (this._lastSecondary === NOTHING || !this._lastSecondary) this._emitEnd();
    }
};
var S$34 = createStream$1("filterBy", mixin$26);
var P$29 = createProperty$1("filterBy", mixin$26);
function filterBy(primary, secondary) {
    return new (primary._ofSameType(S$34, P$29))(primary, secondary);
}
var id2 = function(_, x) {
    return x;
};
function sampledBy(passive, active, combinator) {
    var _combinator = combinator ? function(a, b) {
        return combinator(b, a);
    } : id2;
    return combine([
        active
    ], [
        passive
    ], _combinator).setName(passive, "sampledBy");
}
var mixin$27 = {
    _handlePrimaryValue: function(x) {
        if (this._lastSecondary !== NOTHING) this._emitValue(x);
    },
    _handleSecondaryEnd: function() {
        if (this._lastSecondary === NOTHING) this._emitEnd();
    }
};
var S$35 = createStream$1("skipUntilBy", mixin$27);
var P$30 = createProperty$1("skipUntilBy", mixin$27);
function skipUntilBy(primary, secondary) {
    return new (primary._ofSameType(S$35, P$30))(primary, secondary);
}
var mixin$28 = {
    _handleSecondaryValue: function() {
        this._emitEnd();
    }
};
var S$36 = createStream$1("takeUntilBy", mixin$28);
var P$31 = createProperty$1("takeUntilBy", mixin$28);
function takeUntilBy(primary, secondary) {
    return new (primary._ofSameType(S$36, P$31))(primary, secondary);
}
var mixin$29 = {
    _init: function() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$flushOnEnd = _ref.flushOnEnd, flushOnEnd = _ref$flushOnEnd === undefined ? true : _ref$flushOnEnd;
        this._buff = [];
        this._flushOnEnd = flushOnEnd;
    },
    _free: function() {
        this._buff = null;
    },
    _flush: function() {
        if (this._buff !== null) {
            this._emitValue(this._buff);
            this._buff = [];
        }
    },
    _handlePrimaryEnd: function() {
        if (this._flushOnEnd) this._flush();
        this._emitEnd();
    },
    _onActivation: function() {
        this._primary.onAny(this._$handlePrimaryAny);
        if (this._alive && this._secondary !== null) this._secondary.onAny(this._$handleSecondaryAny);
    },
    _handlePrimaryValue: function(x) {
        this._buff.push(x);
    },
    _handleSecondaryValue: function() {
        this._flush();
    },
    _handleSecondaryEnd: function() {
        if (!this._flushOnEnd) this._emitEnd();
    }
};
var S$37 = createStream$1("bufferBy", mixin$29);
var P$32 = createProperty$1("bufferBy", mixin$29);
function bufferBy(primary, secondary, options /* optional */ ) {
    return new (primary._ofSameType(S$37, P$32))(primary, secondary, options);
}
var mixin$30 = {
    _init: function() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$flushOnEnd = _ref.flushOnEnd, flushOnEnd = _ref$flushOnEnd === undefined ? true : _ref$flushOnEnd, _ref$flushOnChange = _ref.flushOnChange, flushOnChange = _ref$flushOnChange === undefined ? false : _ref$flushOnChange;
        this._buff = [];
        this._flushOnEnd = flushOnEnd;
        this._flushOnChange = flushOnChange;
    },
    _free: function() {
        this._buff = null;
    },
    _flush: function() {
        if (this._buff !== null) {
            this._emitValue(this._buff);
            this._buff = [];
        }
    },
    _handlePrimaryEnd: function() {
        if (this._flushOnEnd) this._flush();
        this._emitEnd();
    },
    _handlePrimaryValue: function(x) {
        this._buff.push(x);
        if (this._lastSecondary !== NOTHING && !this._lastSecondary) this._flush();
    },
    _handleSecondaryEnd: function() {
        if (!this._flushOnEnd && (this._lastSecondary === NOTHING || this._lastSecondary)) this._emitEnd();
    },
    _handleSecondaryValue: function(x) {
        if (this._flushOnChange && !x) this._flush();
        // from default _handleSecondaryValue
        this._lastSecondary = x;
    }
};
var S$38 = createStream$1("bufferWhileBy", mixin$30);
var P$33 = createProperty$1("bufferWhileBy", mixin$30);
function bufferWhileBy(primary, secondary, options /* optional */ ) {
    return new (primary._ofSameType(S$38, P$33))(primary, secondary, options);
}
var f = function() {
    return false;
};
var t = function() {
    return true;
};
function awaiting(a, b) {
    var result = merge([
        map$1(a, t),
        map$1(b, f)
    ]);
    result = skipDuplicates(result);
    result = toProperty(result, f);
    return result.setName(a, "awaiting");
}
var mixin$31 = {
    _init: function(_ref) {
        var fn = _ref.fn;
        this._fn = fn;
    },
    _free: function() {
        this._fn = null;
    },
    _handleValue: function(x) {
        var fn = this._fn;
        var result = fn(x);
        if (result.convert) this._emitError(result.error);
        else this._emitValue(x);
    }
};
var S$39 = createStream("valuesToErrors", mixin$31);
var P$34 = createProperty("valuesToErrors", mixin$31);
var defFn = function(x) {
    return {
        convert: true,
        error: x
    };
};
function valuesToErrors(obs) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defFn;
    return new (obs._ofSameType(S$39, P$34))(obs, {
        fn: fn
    });
}
var mixin$32 = {
    _init: function(_ref) {
        var fn = _ref.fn;
        this._fn = fn;
    },
    _free: function() {
        this._fn = null;
    },
    _handleError: function(x) {
        var fn = this._fn;
        var result = fn(x);
        if (result.convert) this._emitValue(result.value);
        else this._emitError(x);
    }
};
var S$40 = createStream("errorsToValues", mixin$32);
var P$35 = createProperty("errorsToValues", mixin$32);
var defFn$1 = function(x) {
    return {
        convert: true,
        value: x
    };
};
function errorsToValues(obs) {
    var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defFn$1;
    return new (obs._ofSameType(S$40, P$35))(obs, {
        fn: fn
    });
}
var mixin$33 = {
    _handleError: function(x) {
        this._emitError(x);
        this._emitEnd();
    }
};
var S$41 = createStream("endOnError", mixin$33);
var P$36 = createProperty("endOnError", mixin$33);
function endOnError(obs) {
    return new (obs._ofSameType(S$41, P$36))(obs);
}
// Create a stream
// -----------------------------------------------------------------------------
// () -> Stream
// (number, any) -> Stream
// (number, any) -> Stream
// (number, Array<any>) -> Stream
// (number, Function) -> Stream
// (number, Function) -> Stream
// (Function) -> Stream
// (Function) -> Stream
// Target = {addEventListener, removeEventListener}|{addListener, removeListener}|{on, off}
// (Target, string, Function|undefined) -> Stream
// (Function) -> Stream
// Create a property
// -----------------------------------------------------------------------------
// (any) -> Property
// (any) -> Property
// Convert observables
// -----------------------------------------------------------------------------
// (Stream|Property, Function|undefined) -> Property
Observable.prototype.toProperty = function(fn) {
    return toProperty(this, fn);
};
// (Stream|Property) -> Stream
Observable.prototype.changes = function() {
    return changes(this);
};
// Interoperation with other implimentations
// -----------------------------------------------------------------------------
// (Promise) -> Property
// (Stream|Property, Function|undefined) -> Promise
Observable.prototype.toPromise = function(Promise1) {
    return toPromise(this, Promise1);
};
// (ESObservable) -> Stream
// (Stream|Property) -> ES7 Observable
Observable.prototype.toESObservable = toESObservable;
Observable.prototype[$$observable] = toESObservable;
// Modify an observable
// -----------------------------------------------------------------------------
// (Stream, Function|undefined) -> Stream
// (Property, Function|undefined) -> Property
Observable.prototype.map = function(fn) {
    return map$1(this, fn);
};
// (Stream, Function|undefined) -> Stream
// (Property, Function|undefined) -> Property
Observable.prototype.filter = function(fn) {
    return filter(this, fn);
};
// (Stream, number) -> Stream
// (Property, number) -> Property
Observable.prototype.take = function(n) {
    return take(this, n);
};
// (Stream, number) -> Stream
// (Property, number) -> Property
Observable.prototype.takeErrors = function(n) {
    return takeErrors(this, n);
};
// (Stream, Function|undefined) -> Stream
// (Property, Function|undefined) -> Property
Observable.prototype.takeWhile = function(fn) {
    return takeWhile(this, fn);
};
// (Stream) -> Stream
// (Property) -> Property
Observable.prototype.last = function() {
    return last(this);
};
// (Stream, number) -> Stream
// (Property, number) -> Property
Observable.prototype.skip = function(n) {
    return skip(this, n);
};
// (Stream, Function|undefined) -> Stream
// (Property, Function|undefined) -> Property
Observable.prototype.skipWhile = function(fn) {
    return skipWhile(this, fn);
};
// (Stream, Function|undefined) -> Stream
// (Property, Function|undefined) -> Property
Observable.prototype.skipDuplicates = function(fn) {
    return skipDuplicates(this, fn);
};
// (Stream, Function|falsey, any|undefined) -> Stream
// (Property, Function|falsey, any|undefined) -> Property
Observable.prototype.diff = function(fn, seed) {
    return diff(this, fn, seed);
};
// (Stream|Property, Function, any|undefined) -> Property
Observable.prototype.scan = function(fn, seed) {
    return scan(this, fn, seed);
};
// (Stream, Function|undefined) -> Stream
// (Property, Function|undefined) -> Property
Observable.prototype.flatten = function(fn) {
    return flatten(this, fn);
};
// (Stream, number) -> Stream
// (Property, number) -> Property
Observable.prototype.delay = function(wait) {
    return delay(this, wait);
};
// Options = {leading: boolean|undefined, trailing: boolean|undefined}
// (Stream, number, Options|undefined) -> Stream
// (Property, number, Options|undefined) -> Property
Observable.prototype.throttle = function(wait, options) {
    return throttle(this, wait, options);
};
// Options = {immediate: boolean|undefined}
// (Stream, number, Options|undefined) -> Stream
// (Property, number, Options|undefined) -> Property
Observable.prototype.debounce = function(wait, options) {
    return debounce(this, wait, options);
};
// (Stream, Function|undefined) -> Stream
// (Property, Function|undefined) -> Property
Observable.prototype.mapErrors = function(fn) {
    return mapErrors(this, fn);
};
// (Stream, Function|undefined) -> Stream
// (Property, Function|undefined) -> Property
Observable.prototype.filterErrors = function(fn) {
    return filterErrors(this, fn);
};
// (Stream) -> Stream
// (Property) -> Property
Observable.prototype.ignoreValues = function() {
    return ignoreValues(this);
};
// (Stream) -> Stream
// (Property) -> Property
Observable.prototype.ignoreErrors = function() {
    return ignoreErrors(this);
};
// (Stream) -> Stream
// (Property) -> Property
Observable.prototype.ignoreEnd = function() {
    return ignoreEnd(this);
};
// (Stream, Function) -> Stream
// (Property, Function) -> Property
Observable.prototype.beforeEnd = function(fn) {
    return beforeEnd(this, fn);
};
// (Stream, number, number|undefined) -> Stream
// (Property, number, number|undefined) -> Property
Observable.prototype.slidingWindow = function(max, min) {
    return slidingWindow(this, max, min);
};
// Options = {flushOnEnd: boolean|undefined}
// (Stream, Function|falsey, Options|undefined) -> Stream
// (Property, Function|falsey, Options|undefined) -> Property
Observable.prototype.bufferWhile = function(fn, options) {
    return bufferWhile(this, fn, options);
};
// (Stream, number) -> Stream
// (Property, number) -> Property
Observable.prototype.bufferWithCount = function(count, options) {
    return bufferWhile$1(this, count, options);
};
// Options = {flushOnEnd: boolean|undefined}
// (Stream, number, number, Options|undefined) -> Stream
// (Property, number, number, Options|undefined) -> Property
Observable.prototype.bufferWithTimeOrCount = function(wait, count, options) {
    return bufferWithTimeOrCount(this, wait, count, options);
};
// (Stream, Function) -> Stream
// (Property, Function) -> Property
Observable.prototype.transduce = function(transducer) {
    return transduce(this, transducer);
};
// (Stream, Function) -> Stream
// (Property, Function) -> Property
Observable.prototype.withHandler = function(fn) {
    return withHandler(this, fn);
};
// (Stream, Stream -> a) -> a
// (Property, Property -> a) -> a
Observable.prototype.thru = function(fn) {
    return fn(this);
};
// Combine observables
// -----------------------------------------------------------------------------
// (Array<Stream|Property>, Function|undefiend) -> Stream
// (Array<Stream|Property>, Array<Stream|Property>, Function|undefiend) -> Stream
Observable.prototype.combine = function(other, combinator) {
    return combine([
        this,
        other
    ], combinator);
};
// (Array<Stream|Property>, Function|undefiend) -> Stream
Observable.prototype.zip = function(other, combinator) {
    return zip([
        this,
        other
    ], combinator);
};
// (Array<Stream|Property>) -> Stream
Observable.prototype.merge = function(other) {
    return merge([
        this,
        other
    ]);
};
// (Array<Stream|Property>) -> Stream
Observable.prototype.concat = function(other) {
    return concat$1([
        this,
        other
    ]);
};
// () -> Pool
var pool = function() {
    return new Pool();
};
// (Function) -> Stream
// Options = {concurLim: number|undefined, queueLim: number|undefined, drop: 'old'|'new'|undefiend}
// (Stream|Property, Function|falsey, Options|undefined) -> Stream
Observable.prototype.flatMap = function(fn) {
    return new FlatMap(this, fn).setName(this, "flatMap");
};
Observable.prototype.flatMapLatest = function(fn) {
    return new FlatMap(this, fn, {
        concurLim: 1,
        drop: "old"
    }).setName(this, "flatMapLatest");
};
Observable.prototype.flatMapFirst = function(fn) {
    return new FlatMap(this, fn, {
        concurLim: 1
    }).setName(this, "flatMapFirst");
};
Observable.prototype.flatMapConcat = function(fn) {
    return new FlatMap(this, fn, {
        queueLim: -1,
        concurLim: 1
    }).setName(this, "flatMapConcat");
};
Observable.prototype.flatMapConcurLimit = function(fn, limit) {
    return new FlatMap(this, fn, {
        queueLim: -1,
        concurLim: limit
    }).setName(this, "flatMapConcurLimit");
};
// (Stream|Property, Function|falsey) -> Stream
Observable.prototype.flatMapErrors = function(fn) {
    return new FlatMapErrors(this, fn).setName(this, "flatMapErrors");
};
// Combine two observables
// -----------------------------------------------------------------------------
// (Stream, Stream|Property) -> Stream
// (Property, Stream|Property) -> Property
Observable.prototype.filterBy = function(other) {
    return filterBy(this, other);
};
// (Stream, Stream|Property, Function|undefiend) -> Stream
// (Property, Stream|Property, Function|undefiend) -> Property
Observable.prototype.sampledBy = function(other, combinator) {
    return sampledBy(this, other, combinator);
};
// (Stream, Stream|Property) -> Stream
// (Property, Stream|Property) -> Property
Observable.prototype.skipUntilBy = function(other) {
    return skipUntilBy(this, other);
};
// (Stream, Stream|Property) -> Stream
// (Property, Stream|Property) -> Property
Observable.prototype.takeUntilBy = function(other) {
    return takeUntilBy(this, other);
};
// Options = {flushOnEnd: boolean|undefined}
// (Stream, Stream|Property, Options|undefined) -> Stream
// (Property, Stream|Property, Options|undefined) -> Property
Observable.prototype.bufferBy = function(other, options) {
    return bufferBy(this, other, options);
};
// Options = {flushOnEnd: boolean|undefined}
// (Stream, Stream|Property, Options|undefined) -> Stream
// (Property, Stream|Property, Options|undefined) -> Property
Observable.prototype.bufferWhileBy = function(other, options) {
    return bufferWhileBy(this, other, options);
};
// Deprecated
// -----------------------------------------------------------------------------
var DEPRECATION_WARNINGS = true;
function dissableDeprecationWarnings() {
    DEPRECATION_WARNINGS = false;
}
function warn(msg) {
    if (DEPRECATION_WARNINGS && console && typeof console.warn === "function") {
        var msg2 = "\nHere is an Error object for you containing the call stack:";
        console.warn(msg, msg2, new Error());
    }
}
// (Stream|Property, Stream|Property) -> Property
Observable.prototype.awaiting = function(other) {
    warn("You are using deprecated .awaiting() method, see https://github.com/kefirjs/kefir/issues/145");
    return awaiting(this, other);
};
// (Stream, Function|undefined) -> Stream
// (Property, Function|undefined) -> Property
Observable.prototype.valuesToErrors = function(fn) {
    warn("You are using deprecated .valuesToErrors() method, see https://github.com/kefirjs/kefir/issues/149");
    return valuesToErrors(this, fn);
};
// (Stream, Function|undefined) -> Stream
// (Property, Function|undefined) -> Property
Observable.prototype.errorsToValues = function(fn) {
    warn("You are using deprecated .errorsToValues() method, see https://github.com/kefirjs/kefir/issues/149");
    return errorsToValues(this, fn);
};
// (Stream) -> Stream
// (Property) -> Property
Observable.prototype.endOnError = function() {
    warn("You are using deprecated .endOnError() method, see https://github.com/kefirjs/kefir/issues/150");
    return endOnError(this);
};
// Exports
// --------------------------------------------------------------------------
var Kefir = {
    Observable: Observable,
    Stream: Stream,
    Property: Property,
    never: never,
    later: later,
    interval: interval,
    sequentially: sequentially,
    fromPoll: fromPoll,
    withInterval: withInterval,
    fromCallback: fromCallback,
    fromNodeCallback: fromNodeCallback,
    fromEvents: fromEvents,
    stream: stream,
    constant: constant,
    constantError: constantError,
    fromPromise: fromPromise,
    fromESObservable: fromESObservable,
    combine: combine,
    zip: zip,
    merge: merge,
    concat: concat$1,
    Pool: Pool,
    pool: pool,
    repeat: repeat,
    staticLand: staticLand
};
Kefir.Kefir = Kefir;
var $854ec0c23ef25a7c$export$2e2bcd8739ae039 = Kefir;

});


var $brAMX = parcelRequire("brAMX");

var $brAMX = parcelRequire("brAMX");
function $1cde6522c6c4be74$export$e757af7acee9de82() {
    const sAdd = $brAMX.fromEvents(document.querySelector("button[name=add]"), "click").map(()=>1);
    const sSub = $brAMX.fromEvents(document.querySelector("button[name=sub]"), "click").map(()=>-1);
    const sDelta = $brAMX.merge([
        sAdd,
        sSub
    ]);
    const result = sDelta.scan((acc, v)=>acc + v, 0);
    result.onValue((v)=>{
        document.getElementById("val").innerHTML = v;
    });
}


function $2b6e161c9edcf319$var$canvas() {
    const c = document.querySelector("canvas");
    const ctx = c.getContext("2d");
    c.width = c.clientWidth;
    c.height = c.clientHeight;
    const rect = c.getBoundingClientRect();
    const toXY = (e)=>({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top
        });
    const drawLine = ([start, end])=>{
        if (start == null || end == null) return;
        ctx.clearRect(0, 0, c.width, c.height);
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(start.x, start.y);
        ctx.lineTo(end.x, end.y);
        ctx.stroke();
        ctx.restore();
    };
    const drawRect = ([start, end])=>{
        if (start == null || end == null) return;
        ctx.clearRect(0, 0, c.width, c.height);
        ctx.save();
        ctx.fillStyle = "hsla(32.9, 100%, 90%, 0.8)";
        ctx.fillRect(start.x, start.y, end.x - start.x, end.y - start.y);
        ctx.restore();
    };
    const sPointerDown = $brAMX.fromEvents(c, "pointerdown").map(toXY);
    const sPointerMove = $brAMX.fromEvents(c, "pointermove").map(toXY);
    const sPointerUp = $brAMX.fromEvents(c, "pointerup").map(toXY);
    sPointerDown.flatMap((down)=>sPointerMove.scan(([start], next)=>[
                start,
                next
            ], [
            down,
            null
        ]).takeUntilBy(sPointerUp)).onValue(drawRect);
    sPointerDown.flatMapLatest((down)=>sPointerUp.scan(([start], next)=>[
                start,
                next
            ], [
            down,
            null
        ])).onValue(drawLine);
}
function $2b6e161c9edcf319$var$box() {
    const container = document.getElementById("click-n-drag");
    const containerSize = container.getBoundingClientRect();
    const box = container.querySelector("div.box");
    const boxSize = box.getBoundingClientRect();
    const maxTopValue = containerSize.height - boxSize.height;
    const maxLeftValue = containerSize.width - boxSize.width;
    const sBoxPointerDown = $brAMX.fromEvents(box, "pointerdown");
    const sPointerMove = $brAMX.fromEvents(container, "pointermove");
    const sPointerUp = $brAMX.fromEvents(container, "pointerup");
    const isSelected = sBoxPointerDown.merge(sPointerUp).scan((prev)=>!prev, false);
    isSelected.onValue((isSelected)=>isSelected ? box.classList.add("selected-box") : box.classList.remove("selected-box"));
    sBoxPointerDown.flatMap(()=>sPointerMove.takeUntilBy(sPointerUp)).onValue((e)=>{
        const size = e.target.getBoundingClientRect();
        const offsetX = e.clientX - size.left;
        const offsetY = e.clientY - size.top;
        const x = size.left - containerSize.left + offsetX;
        const y = size.top - containerSize.top + offsetY;
        // Kinda work
        // @FIXME: Make the box to move only within the container boundary
        box.style.left = Math.min(x, maxLeftValue) + "px";
        box.style.top = Math.min(y, maxTopValue) + "px";
    });
}
(0, $1cde6522c6c4be74$export$e757af7acee9de82)();
$2b6e161c9edcf319$var$canvas();
$2b6e161c9edcf319$var$box();


//# sourceMappingURL=index.b3b24f11.js.map
